import Link, { LinkProps } from "next/link";
import React from "react";
import { sanitizeRoutePath } from ".";

type SafeLinkProps = LinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    children?: React.ReactNode;
};

function SafeLink({ href, as, ...rest }: SafeLinkProps) {
    const safeHref = typeof href === "string" ? sanitizeRoutePath(href) : href;
    const safeAs = typeof as === "string" ? sanitizeRoutePath(as) : as;
    return <Link href={safeHref} as={safeAs} {...rest} />;
}

export default SafeLink;
